
<div class="showcase-profile">
  <spinner v-if="!loaded" />

  <template v-else>
    <div class="top">
      <align small-gap>
        <span v-if="numLikes">{{ $filters.number(numLikes) }}</span>

        <icon-button
          v-if="!isMyCard"
          :tooltip="hasFavorite ? 'Remove favorite' : 'Add to favorites'"
          :icon="hasFavorite ? 'favorite' : 'favorite_border'"
          @click="handleFavorite"
        />

        <icon-button
          tooltip="Close card"
          icon="close"
          @click="close"
        />
      </align>
    </div>

    <section class="details">
      <card-profile-images :card="card" />

      <div class="stats">
        <div class="main">
          <div class="card-text">
            {{ card.year }} {{ card.set }} {{ card.player }}{{ card.number ? ` #${card.number}` : '' }}
          </div>

          <card-item-chips
            profile
            :card="card"
          />
        </div>

        <div class="stat-items">
          <owner-stat-item :owner="card" />

          <stat-item
            label="Date Added"
            :value="$filters.date(card.dateAdded)"
          />
        </div>

        <div class="button-row">
          <btn
            v-if="!!profileLink"
            icon="question_answer"
            as="a"
            target="_blank"
            :href="profileLink"
          >
            Message Owner
          </btn>

          <btn
            v-if="!!cardId"
            icon="cl_ladder"
            kind="secondary"
            @click="goToLadderCard"
          >
            View Ladder Stats
          </btn>
        </div>
      </div>
    </section>

    <showcase-card-more-cards :card="card" :cards="moreCards" />
  </template>
</div>
